import { SmokingRooms } from "@mui/icons-material";
import { FormSelectCompleted } from "@/components/form/FormSelectCompleted";
import { useMedicalCareContext } from "@/contexts/MedicalCareContext";
import InputText from "@/components/form/InputText";
import { useState, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { smokingOptions } from "../constants/options";
import { CollapsibleSection } from "./CollapsibleSection";

export function SmokingFields() {
    const { control, setValue } = useMedicalCareContext();
    const [isOpen, setIsOpen] = useState(false);

    const smokingStatus = useWatch({
        control,
        name: "Anthropometric.smoking",
        defaultValue: null,
    });

    const showSmokingFields =
        smokingStatus &&
        smokingStatus.value !== "Never smoker" &&
        smokingStatus.value !== "";

    useEffect(() => {
        if (!showSmokingFields) {
            setValue("Anthropometric.smokingDurationYears", "");
            setValue("Anthropometric.smokingCigarettesPerDay", "");
        }
    }, [showSmokingFields, setValue]);

    return (
        <CollapsibleSection
            title="Tabagismo"
            icon={<SmokingRooms sx={{ fontSize: "24px", color: "primary.main" }} />}
            isOpen={isOpen}
            onToggle={() => setIsOpen(!isOpen)}
        >
            <FormSelectCompleted
                control={control}
                name="Anthropometric.smoking"
                label="Tabagismo"
                selectOptions={smokingOptions}
            />
            {showSmokingFields && (
                <>
                    <InputText
                        label="Tempo de tabagismo (anos)"
                        name="Anthropometric.smokingDurationYears"
                        control={control}
                        type="number"
                    />
                    <InputText
                        label="Quantidade (cigarros/dia)"
                        name="Anthropometric.smokingCigarettesPerDay"
                        control={control}
                        type="number"
                    />
                </>
            )}
        </CollapsibleSection>
    );
}

